import * as runOptionsUtils from './runOptionsUtils';
import * as analytics from './commons/testimAnalytics';
import { ArgError } from './errors';
import type { OptionValues } from 'commander';
import type { AgentModeOptions } from './runOptions';


export function isAgentFlow(program: OptionValues) {
    if (program.start) {
        analytics.track(null, 'cli-start-command', { downloadBrowser: Boolean(program.downloadBrowser) });
    }
    if (program.startV2 || program.start || program.agent) {
        return true;
    }

    return false;
}

export async function runAgentFlow(program: OptionValues): Promise<AgentModeOptions> {
    const startTestimBrowser = !!program.start;

    if (Number.isNaN(program.agentPort)) {
        throw new ArgError('Agent port is not number');
    }

    const playerUrl = runOptionsUtils.getPlayerUrl(program);

    // eslint-disable-next-line no-console
    console.log('Start Testim CLI on Agent mode');
    return {
        project: program.project,
        token: program.token,
        agentMode: true,
        agentPort: program.agentPort,
        agentBind: program.agentBind,
        openEditor: program.openEditor,
        startTestimBrowser,
        ext: program.ext,
        extensionPath: program.extensionPath,
        playerLocation: program.playerPath || playerUrl,
        canary: program.canary,
        playerPath: program.playerPath,
        playerRequirePath: program.playerRequirePath,
        downloadBrowser: Boolean(program.downloadBrowser),
    };
}
